import { filter, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import moment from 'moment'
import { track } from 'tracking/mixPanel'
import { STATUS } from 'constants/checkout'
import * as Actions from 'store/actions/index.ts'
import { getFormatParticipants } from 'domain/pricerParticipants'
import {
  getBenefitsConf,
  getDaysSinceStartSale,
  getFilteredProductsInParentScope,
  getHasPackages,
  getHasVisibleDepartureCityPicker,
  getHasVisibleDepartureDatePicker,
  getHasVisibleDurationPicker,
  getNormalizedNbSubUniversesInCatalog,
  getNormalizedNbUniversesInCatalog,
  getOperationCode,
  getOperationId,
  getPriceUnit,
  getProductCallPrice,
  getProductPriceUnit,
  getProductPriceValue,
  getProductSourceKey,
  getProductTitle,
  getSaleStartTime,
  getSelectedBenefits,
  getSelectedCheckin,
  getSelectedDepartureCity,
  getSelectedDuration,
  getSelectedParticipants,
  getSubUniverseName,
  getUniverseName
} from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

const mapStateToMPEvent = (eventName, state) => {
  const MPEvent = {
    '# of References': getFilteredProductsInParentScope(state).length,
    '# of Sub Universes': getNormalizedNbSubUniversesInCatalog(state),
    '# of Universes': getNormalizedNbUniversesInCatalog(state),
    'Days Since Sale Start': getDaysSinceStartSale(state),
    'Event Name': eventName,
    'Interaction Type': 'Technical',
    'Lowest Price': getProductCallPrice(state),
    'OccurrenceDate': moment.utc().format(),
    'Operation Code': getOperationCode(state),
    'Product': getProductTitle(state),
    'Product ID': getProductSourceKey(state),
    'Product Price': getProductPriceValue(state),
    'Sale Start Time': getSaleStartTime(state),
    'SaleId': getOperationId(state),
    'Under Universe': getSubUniverseName(state),
    'Unit': getProductPriceUnit(state),
    'Universe': getUniverseName(state)
  }

  if (getHasPackages(state)) {
    const hasVisibleDepartureCityPicker = getHasVisibleDepartureCityPicker(state)
    const hasVisibleDurationPicker = getHasVisibleDurationPicker(state)
    const hasVisibleDepartureDatePicker = getHasVisibleDepartureDatePicker(state)
    const selectedDepartureCity = getSelectedDepartureCity(state)
    const selectedDuration = getSelectedDuration(state)
    const selectedCheckin = getSelectedCheckin(state)
    const selectedParticipants = getSelectedParticipants(state)
    const benefitsConf = getBenefitsConf(state)
    const selectedBenefits = getSelectedBenefits(state)
    const priceUnit = getPriceUnit(state)

    if (hasVisibleDepartureCityPicker) { MPEvent['Departure City'] = selectedDepartureCity.label }
    if (hasVisibleDurationPicker) { MPEvent['Number Of Nights'] = selectedDuration.nights }
    if (hasVisibleDepartureDatePicker) { MPEvent['Search Date'] = moment(selectedCheckin).format('YYYY-MM-DDTHH:mm:ss') }
    if (selectedParticipants) { MPEvent['Family Config'] = getFormatParticipants(selectedParticipants) }
    if (selectedBenefits) {
      MPEvent['Offer Type Category'] = benefitsConf?.labels.singular
      MPEvent['Number Of Offer Type Selected'] = selectedBenefits
    }
    if (priceUnit) { MPEvent.Unit = priceUnit }
  }

  return MPEvent
}

const startClientRedirectionEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.checkout.CHECKOUT_STATUS_CHANGED),
  filter(action => action.payload.status === STATUS.REDIRECTING),
  tap(() => {
    const eventName = 'Start Client Redirection'

    track(eventName, mapStateToMPEvent(eventName, state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default startClientRedirectionEpic
